import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import { trackClickAddTrigger } from "./utils/telemetry"

import "./diy_tanda_selected.scss"

export default function DIYTandaSelect({ label, disabled, onClick }) {
  const placeholder = label == "if" ? "this" : "that"
  const classes = classnames("tanda-select-block", {
    disabled,
    "then-that": placeholder === "that",
  })

  const click = () => {
    trackClickAddTrigger({ step: label == "if" ? "trigger" : "action" })

    onClick()
  }

  return (
    <section styleName={classes} onClick={disabled ? () => {} : click}>
      <span styleName="label">
        {label} {placeholder}
      </span>
      <button className="button-tertiary button-on-color">Add</button>
    </section>
  )
}

DIYTandaSelect.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.oneOf(["if", "then"]),
  onClick: PropTypes.func,
}

DIYTandaSelect.defaultProps = {
  disabled: false,
}
